import { shallowMount } from "@vue/test-utils";

describe("Example test", () => {
  it("should be true", () => {
    expect(true).toBe(true);
  });
});
